import React from "react";
import "../../App.css";
import Home from "../Home";
import WhoWeAre from "../WhoWeAre/WhoWeAre";
import WhatWeDo from "../WhatWeDo/WhatWeDo";
import Techstackpdf from "../Techstack/Techstackpdf";
import ContactUs from "../Contact/ContactUs";
import Footer from "../Footer/Footer";
import OurServices from "../OurServices/OurServices";

const HomePagePDF = () => {
  return (
    <div >
      <Home home="pdf" />
      <div className="px-20 flex justify-center" style={{height:"100vh"}} >
      <WhatWeDo whatwedo="pdf"  />
      </div>
      <div className="px-20 flex justify-center " style={{height:"100vh"}}>
      <OurServices whatwedo="pdf"  />
      </div>
      <div className="px-20  flex items-center  justify-center" style={{height:"100vh"}}>
      <Techstackpdf techstack="pdf"  />
      </div>
      <div className="px-20 flex  justify-center" style={{height:"100vh",paddingTop:"180px"}}>
      <WhoWeAre whoweare="pdf" />
      </div>
      <div className="py-20 relative " style={{height:"100vh"}}>
      <div className="px-20 pt-10 flex justify-center" >
      <ContactUs contact="pdf" />
      </div>
      <div className=" absolute bottom-0 left-1/2 transform -translate-x-1/2 w-full"  style={{backgroundColor:"#e2e8f0"}}>
      <Footer footer="pdf" />
      </div>
      </div>
   
    </div>
  );
};

export default HomePagePDF;
